<template>
  <div>
    <PaymentCard :step="step">
      <b-row class="text-center py-2">
        <b-col xl="1" offset-xl="2" md="1" offset-md="2" sm="12" class="col-image">
          <img :src="`${publicPath}/static/images/red.svg`" class="error-image" />
        </b-col>
        <b-col xl="7" md="8" sm="12">
          <div class="payment-message">¡Lo sentimos! Tu pago no se ha podido realizar</div>
        </b-col>
      </b-row>
      <b-row class="text-center d-flex justify-content-center">
        <b-col md="7">
          <b-card class="detail-table">
            <b-table
              striped
              :fields="fields"
              :items="items"
              :sort-by.sync="sortBy"
              thead-class="d-none"
            ></b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pt-3 pb-0 justify-content-center">
        <b-col md="7">
          <div class="payment-causes-title">Las posibles causas de este rechazo son:</div>
          <div>
            <b-list-group class="payment-causes-list-group">
              <b-list-group-item>
                <img class="arrow-list" :src="`${publicPath}/static/images/arrow.svg`" /> Error en el ingreso de los datos de su tarjeta de crédito o débito (fecha y/o código de seguridad).
              </b-list-group-item>
              <b-list-group-item>
                <img class="arrow-list" :src="`${publicPath}/static/images/arrow.svg`" /> Su tarjeta de crédito o débito no cuenta con el cupo necesario para cancelar la compra.
              </b-list-group-item>
              <b-list-group-item>
                <img class="arrow-list" :src="`${publicPath}/static/images/arrow.svg`" /> Tarjeta aún no habilitada en el sistema financiero.
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="text-center pt-1 pb-4">
        <b-col md="12" class="pb-5 pt-2">
          <b-button class="go-back py-2" variant="primary" to="/billing">
            Volver a intentar
          </b-button>
        </b-col>
      </b-row>
    </PaymentCard>
  </div>
</template>

<script>
import PaymentCard from "@/components/PaymentCard.vue";
import config from "@/config";

export default {
  components: { PaymentCard },
  computed: {
    transaction() {
      return this.$route.params.transaction.trim();
    },
    items() {
      return this.$store.getters.errorVoucher;
    }
  },
  mounted() {
    this.$store.dispatch("retrieveErrorVoucher", {
      transaction: this.transaction
    });
    this.$store.dispatch("insertErrorInteraction");
  },
  created() {
    try {
      window.digitalData = {
        origen: this.$store.getters.paymentProvider.touch,
        metodoPago: this.$store.getters.paymentProvider.paymentMethod,
        motivoError: "Problemas con el provedor de pago"
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event':'vpv',});
      window.dataLayer.push({'event':'FlujoPagoServipagError',});
    } catch (e) {}
  },
  data() {
    return {
      sortBy: "sort",
      step: 3,
      fields: [{ key: "desc" }, { key: "val" }],
      publicPath: config.url.base
    };
  }
};
</script>

<style lang="scss">
@import "@/style/main.scss";
@import "@/style/vars.scss";
@import "@/style/functions.scss";
@import "@/style/mixin.scss";
.col-image {
  padding-right: 0;
}
.payment-message {
  color: #4a4a4a;
  @include font-bold(24px);
}
.detail-table {
  .card-body {
    padding: 0;
    .table th,
    .table td {
      border-top: 0;
      text-align: left;
      padding-left: 10px;
    }
    .table {
      color: #6b6b6b;
      margin: 0;
      font-size: 14px;
    }
  }
}
.payment-causes-title {
  color: #6b6b6b;
  @include font-bold(16px);
}
.payment-causes-list-group {
  padding: 0.2rem 0;
  .list-group-item {
    font-size: 14px;
    color: #6b6b6b;
    padding: 0.5rem;
    border-radius: 0;
    border: 0;
    .arrow-list {
      margin-bottom: 4px;
    }
  }
}
@media (min-width: 768px) {
  .error-image {
    float: right !important;
  }
  .payment-message {
    float: left !important;
  }
}
@media (min-width: 576px) {
  .col-image {
    padding-bottom: 10px;
  }
}
.go-back {
  font-size: 16px !important;
  > a {
    color: white;
    &:hover {
      text-decoration: none;
    }
  }
}
@include media-breakpoint-up(xl) {
  .detail-table {
    .card-body {
      .table th,
      .table td {
        padding-left: 80px;
      }
    }
  }
}
</style>


